import ProductList from "../ProductList";
import { useTranslation } from "react-i18next";
import styles from "./productlistblock.module.css";
export default function ProductListBlock() {
  const { t } = useTranslation();
  return (
    <div className={`mt-5 mx-5 ${styles.block}`}>
      <h2>{t("product_list")}</h2>
      <hr></hr>
      <ProductList />
    </div>
  );
}
